import { NgModule, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { FaIconLibrary, FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faChevronDown, faChevronUp, faSort, faSortDown, faSortUp } from '@fortawesome/pro-light-svg-icons';
import { IonicModule } from '@ionic/angular';
import { DialogLayoutModule } from '@tcc-mono/shared/ui/dialog-layout';
import { SharedUtilsModule } from '@tcc-mono/shared/utils';
import { StableDialogModule } from '@tcc-mono/vandijk/web/crm/feature/stables/stable-dialog';
import { AnimalLookupDialogComponent } from './animal-lookup-dialog.component';
import { AnimalInfoDialogComponent } from './animal-info-dialog.component';
import { RvoVerblijfplaatsenTimelineComponent } from './rvo-verblijfplaatsen-timeline.component';
import { RvoUbnMapDialogComponent } from './rvo-ubn-map-dialog.component';
import { RvoAnimalRouteMapDialogComponent } from './rvo-animal-route-map-dialog.component';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    DialogLayoutModule,
    IonicModule,
    FontAwesomeModule,
    SharedUtilsModule,
    StableDialogModule,
  ],
  declarations: [
    AnimalLookupDialogComponent,
    AnimalInfoDialogComponent,
    RvoVerblijfplaatsenTimelineComponent,
    RvoUbnMapDialogComponent,
    RvoAnimalRouteMapDialogComponent,
  ],
  exports: [
    AnimalLookupDialogComponent,
    AnimalInfoDialogComponent,
    RvoVerblijfplaatsenTimelineComponent,
    RvoUbnMapDialogComponent,
    RvoAnimalRouteMapDialogComponent,
  ]
})
export class AnimalLookupDialogModule {
  private readonly _lib = inject(FaIconLibrary);

  constructor() {
    this._lib.addIcons(faChevronUp, faChevronDown, faSort, faSortUp, faSortDown);
  }
}
